<template>
    <div id="content" v-if="user">
        <div class="container">
            <h1>{{ $t('account.invoices') }}</h1>
            <account-tabs active-item="invoices"/>
            <invoices/>
        </div>
    </div>
</template>

<script>
  import AccountTabs from '../../components/AccountTabs.vue';
  import Invoices from '../../components/account/Invoices.vue';

  export default {
    components: {
      AccountTabs,
      Invoices
    },
  };
</script>
